import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";
import {TaskTuru} from "../../../enum/TaskTuru";
import app from "@/main";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {EvrakGonderTaskHandler} from "./EvrakGonderTaskHandler";
import {MtsOdemeTaskHandler} from "./MtsOdemeTaskHandler";
import {HarcMasrafOdeTaskHandler} from "./HarcMasrafOdeTaskHandler";
import {TopluHacizHazirlaTaskHandler} from "./TopluHacizHazirlaTaskHandler";
import {HazirEvrakGonderTaskHandler} from "./HazirEvrakGonderTaskHandler";
import {TakipSorgulaTaskHandler} from "./TakipSorgulaTaskHandler";
import {UyapTakipTevziAlTaskHandler} from "./UyapTakipTevziAlTaskHandler";
import {UyapTakipOdemeYapTaskHandler} from "./UyapTakipOdemeYapTaskHandler";
import {MakbuzIndirTaskHandler} from "./MakbuzIndirTaskHandler";
import {MtsTakipTevziAlTaskHandler} from "./MtsTakipTevziAlTaskHandler";
import {TopluDigerTalepGonderTaskHandler} from "./TopluDigerTalepGonderTaskHandler";
import {TopluTebligatGonderTaskHandler} from "./TopluTebligatGonderTaskHandler";
import {TopluHacizGonderTaskHandler} from "./TopluHacizGonderTaskHandler";
import {EvrakIndirTaskHandler} from "./EvrakIndirTaskHandler";
import {MtsTebligatGonderTaskHandler} from "./MtsTebligatGonderTaskHandler";
import {MtsTakipOdemeYapTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/MtsTakipOdemeYapTaskHandler";
import {UyapHizliTakipAcTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/UyapHizliTakipAcTaskHandler";
import {BarkodSorgulaTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/BarkodSorgulaTaskHandler";
import {TebligatSenkronTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/TebligatSenkronTaskHandler";
import {MtsHizliTakipAcTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/MtsHizliTakipAcTaskHandler";
import {EskiMtsHizliTakipAcTaskHandler} from "@/plugins/uyap-plugin/store/modules/TaskHandler/EskiMtsHizliTakipAcTaskHandler";
import {istekOlcumu} from "@/plugins/uyap-plugin/IstekOlcumu";
import {
    kimlikKapisiHatasiMi,
    kimlikKapisiHatasiniAl,
    kimlikKapisiBayraginiTemizle
} from "@/plugins/uyap-plugin/OturumKimligi";
import {uyapEngelBayraginiAl, uyapEngelBayraginiTemizle} from "@/plugins/uyap-plugin/UyapEngeli";

/**
 * K1-A: UYAP engeli görülen görevde "kısmi sonuç" BITTI_BASARILI kalmaz, BITTI_EKSIK olur. Yalnız SALT OKUMA
 * türleri: gönderim/ödeme/tevzi türlerinde BASARILI "yan etki tamamlandı" demektir; EKSIK yeniden çalıştırmayı
 * (çift gönderim/ödeme) davet eder.
 */
const ENGELDE_EKSIK_SAYILAN_TURLER: TaskTuru[] = [
    TaskTuru.takip_sorgula, TaskTuru.tebligat_senkron, TaskTuru.makbuz_indir, TaskTuru.evrak_indir
];

export class TaskHandler {
    async handle(task: ITask) {
        // SIRADA kontrolünün dışında: duraklatılıp devam eden görevlerde
        // önceki turun metrikleri birikmesin.
        istekOlcumu.sifirla();

        if (task.status == TaskDurum.SIRADA) {
            task.status = TaskDurum.ISLENIYOR;
            // started_at API tarafında ISLENIYOR geçişinde damgalanır.
            // Ana görevi de API kendisi ISLENIYOR yapar ve diğer başlamış paketleri
            // BEKLEMEDE'ye düşürür; burada ayrıca güncellemek hem gereksiz bir PUT +
            // tam görev listesi çekimi üretiyor hem de o mantıkla çakışıyordu.
            await app.$store.dispatch('putTask', {
                id: task.id,
                status: task.status
            });
        }

        let handler: AbstractTaskHandler;
        console.log("TASK is hizli_takip_ac", task.task_type_id == TaskTuru.hizli_takip_ac);
        switch (task.task_type_id) {
            case TaskTuru.takip_hazirla:
                handler = new UyapTakipTevziAlTaskHandler();
                break;
            case TaskTuru.takip_ac:
                handler = new UyapTakipOdemeYapTaskHandler();
                break;
            case TaskTuru.mts_takip_hazirla:
                handler = new MtsTakipTevziAlTaskHandler();
                break;
            case TaskTuru.mts_takip_ac:
                handler = new MtsTakipOdemeYapTaskHandler();
                break;
            case TaskTuru.evrak_gonder:
                handler = new EvrakGonderTaskHandler();
                break;
            case TaskTuru.mts_odeme:
                handler = new MtsOdemeTaskHandler();
                break;
            case TaskTuru.harc_masraf_ode:
                handler = new HarcMasrafOdeTaskHandler();
                break;
            case TaskTuru.toplu_haciz_hazirla:
                handler = new TopluHacizHazirlaTaskHandler();
                break;
            case TaskTuru.toplu_haciz_gonder:
                handler = new TopluHacizGonderTaskHandler();
                break;
            case TaskTuru.toplu_tebligat_hazirla:
                handler = new TopluTebligatGonderTaskHandler();
                break;
            case TaskTuru.toplu_genel_talep_hazirla:
                handler = new TopluDigerTalepGonderTaskHandler();
                break;
            case TaskTuru.hazir_evrak_gonder:
                handler = new HazirEvrakGonderTaskHandler();
                break;
            case TaskTuru.makbuz_indir:
                handler = new MakbuzIndirTaskHandler();
                break;
            case TaskTuru.takip_sorgula:
                handler = new TakipSorgulaTaskHandler();
                break;
            case TaskTuru.evrak_indir:
                handler = new EvrakIndirTaskHandler();
                break;
            case TaskTuru.mts_tebligat_gonder:
                handler = new MtsTebligatGonderTaskHandler();
                break;
            case TaskTuru.hizli_takip_ac:
                handler = new UyapHizliTakipAcTaskHandler();
                break;
            case TaskTuru.tebligat_senkron:
                handler = new TebligatSenkronTaskHandler();
                break;
            case TaskTuru.barkod_sorgula:
                handler = new BarkodSorgulaTaskHandler();
                break;
            case TaskTuru.mts_hizli_takip_ac:
                handler = new MtsHizliTakipAcTaskHandler();
                break;
            case TaskTuru.eski_mts_hizli_takip_ac:
                handler = new EskiMtsHizliTakipAcTaskHandler();
                break;
        }
        try {
            // Kimlik kapısı bayrağı bu görevin süresi için sıfırlanır (bkz. OturumKimligi).
            kimlikKapisiBayraginiTemizle();
            uyapEngelBayraginiTemizle();
            //@ts-ignore
            let taskResult: ITask = await handler.handle(task);
            // Kapı bu görev sırasında kapandıysa ve görev BAŞARIYLA bitmediyse: yürütücü hatayı
            // kodsuz sarmış ya da yutup BITTI_EKSIK/BITTI_HATALI'ya çevirmiş olabilir. Hiçbir BITTI_*
            // PUT'u atılmadan kodlu kapı hatası fırlatılır; çocuk ISLENIYOR kalır (aşağıdaki catch).
            const kapi = kimlikKapisiHatasiniAl();
            if (kapi && taskResult?.status != TaskDurum.BITTI_BASARILI) {
                throw kapi;
            }
            let status = taskResult.status;
            if (!(taskResult.status == TaskDurum.BITTI_EKSIK || taskResult.status == TaskDurum.BITTI_HATALI))
                status = TaskDurum.BITTI_BASARILI
            // K1-A: engel bu görev sırasında görüldüyse (yürütücü hatayı yutmuş ya da kodsuz sarmış olabilir)
            // dosya hatalı/eksik biter, açıklama UYAP'ın özgün metni olur; ölçümde metrics.uyapEngeli taşınır.
            const engel = uyapEngelBayraginiAl();
            const tur = task.task_type_id;
            if (engel && status == TaskDurum.BITTI_BASARILI && tur !== undefined && ENGELDE_EKSIK_SAYILAN_TURLER.indexOf(tur) >= 0)
                status = TaskDurum.BITTI_EKSIK;
            // finished_at API'de damgalanır; metrics ise yalnızca istemcide var.
            let payload: any = {
                id: taskResult.id,
                status: status,
                response: taskResult.response,
                result: taskResult.result,
                description: engel && status != TaskDurum.BITTI_BASARILI ? engel.metin : taskResult.description,
                metrics: istekOlcumu.ozet()
            }
            // DEV-3302: harç muaf dosyada takip açılıp hash kaydı güncellenemezse hazırla görevi
            // BITTI_EKSIK biter; tevzi alınmış olduğu için birim bilgisi yine yazılır.
            if ((taskResult.status == TaskDurum.BITTI_BASARILI || taskResult.status == TaskDurum.BITTI_EKSIK) &&
                (task.task_type_id == TaskTuru.takip_hazirla || task.task_type_id == TaskTuru.mts_takip_hazirla)) {
                payload.birim_id = taskResult.response.tevziBilgileri.birimID;
                if (task.task_type_id == TaskTuru.mts_takip_hazirla)
                    payload.birim_adi = "Merkezi Takip Sistemi";
                else
                    payload.birim_adi = taskResult.response.tevziBilgileri.birimAdi;
                payload.uyap_dosya_acilis_tarihi = new Date(this.tarihiFormatla(taskResult.response.tevziBilgileri.dosyaAcilisTarihi));
            }
            await app.$store.dispatch('putTask', payload);
        } catch (error) {
            // Kimlik kapısı (uyuşmazlık / hesap TCKN'si bilinmiyor): görev BAŞARISIZ değil,
            // bot durdurulacak. BITTI_HATALI yazılmaz; hata yeniden fırlatılır, çocuk
            // ISLENIYOR kalır ve Başlat sonrası next-task onu geri verir.
            // Yürütücü hatayı `new Error(e.message)` ile kodsuz sarmışsa kod kaybolmuştur;
            // bu durumda bayraktaki kodlu kapı hatası fırlatılır.
            const kapi = kimlikKapisiHatasiniAl();
            if (kimlikKapisiHatasiMi(error)) {
                kimlikKapisiBayraginiTemizle();
                throw error;
            }
            if (kapi) {
                kimlikKapisiBayraginiTemizle();
                throw kapi;
            }
            console.error('Bitti Hatalı', error);
            // K1-A: engel görüldüyse açıklama UYAP'ın özgün metni (bayrak, kodu kaybolmuş sarmalı hatayı da kapsar).
            const engel = uyapEngelBayraginiAl();
            // finished_at API tarafında bitiş durumuna geçişte damgalanır.
            await app.$store.dispatch('putTask', {
                id: task.id,
                status: TaskDurum.BITTI_HATALI,
                // Toplu haciz gönderimi UYAP'a giden talepleri çalışırken response'a yazar. Hata
                // nesnesiyle ezilirse görev yeniden başlatıldığında gitmiş evraklar ikinci kez gider.
                response: task.response?.gonderilenTalepAnahtarlari ? task.response : error,
                result: task.result,
                metrics: istekOlcumu.ozet(),
                description: engel ? engel.metin : error.message
            });
        }
    }

    tarihiFormatla(tarih: string): string{
        const parts = tarih.split(' ');             // Boşluklardan böl
        const dateParts = parts[0].split('/');      // Tarihi '/' işaretlerinden böl
        const timeParts = parts[1].split(':');      // Saati ':' işaretlerinden böl
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timeParts.join(':')}`;
    }
}